export default function HeroSection() {
  const stats = [
    { value: '10万+', label: '高清影视资源' },
    { value: '每日更新', label: '同步热播剧集' },
    { value: '无广告', label: '纯净观影体验' },
  ];

  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20golden%20and%20deep%20red%20lighting%2C%20abstract%20film%20reel%20textures%2C%20soft%20bokeh%20effects%2C%20elegant%20movie%20theater%20ambiance%2C%20dramatic%20lighting%20with%20rich%20shadows%2C%20luxurious%20velvet%20curtain%20textures%2C%20cinematic%20color%20grading%20with%20warm%20tones%2C%20no%20text%20or%20people&width=1920&height=1080&seq=hero-bg-97movie-01&orientation=landscape"
          alt="97影视高清观影氛围"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/25 mb-6">
              <i className="ri-fire-line text-accent-500 text-sm"></i>
              <span className="text-xs md:text-sm font-medium text-accent-600 whitespace-nowrap">全网热播 · 高清秒播</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-black text-white leading-tight tracking-tight">
              97影视
              <span className="block text-accent-400 mt-1">高清免费在线观看平台</span>
            </h1>

            <p className="text-base md:text-lg text-white/70 mt-3 font-medium tracking-wide">
              海量资源 · 极速秒播 · 纯净无广告
            </p>

            <p className="mt-6 text-sm md:text-base text-white/60 leading-relaxed max-w-xl mx-auto lg:mx-0">
              97影视致力于打造全网最流畅的高清免费观影平台，收录海量电影、电视剧、综艺、动漫资源。
              每日同步更新热播内容，采用先进播放技术确保不卡顿秒播体验，全程无广告干扰，
              让每一次观影都成为纯粹的享受。无论是最新大片还是经典老片，这里都能满足你的高清观影需求。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mt-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/50 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mt-8">
              <button
                onClick={() => scrollTo('#carousel')}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即观影
              </button>
              <button
                onClick={() => scrollTo('#index')}
                className="w-full sm:w-auto px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-medium text-sm rounded-lg border border-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                <i className="ri-grid-line mr-2"></i>
                浏览专题
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-xl overflow-hidden aspect-[4/3] lg:aspect-[16/10]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20golden%20and%20amber%20lighting%2C%20abstract%20film%20strip%20elements%2C%20vintage%20cinema%20projector%20glow%2C%20soft%20dramatic%20shadows%2C%20elegant%20theater%20curtain%20textures%2C%20rich%20warm%20color%20palette%2C%20no%20text%20or%20people%2C%20luxurious%20cinematic%20mood&width=1200&height=900&seq=hero-visual-97movie-02&orientation=landscape"
                alt="97影视高清观影体验"
                className="w-full h-full object-cover rounded-xl"
              />
              <div className="absolute inset-0 rounded-xl ring-1 ring-inset ring-white/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}